'use client'

import {GlobalErrorPage} from '@fitro/error-ui'

export default function NotFound() {
    return <GlobalErrorPage fallbackHref="/calendar" logoSrc="/logo.svg" heroSrc="/fitro-error-recovery.webp"/>
}
